export const FETCH_CAPACITY_INPUT_REQUEST = 'FETCH_CAPACITY_INPUT_REQUEST';
export const FETCH_CAPACITY_INPUT_SUCCESS = 'FETCH_CAPACITY_INPUT_SUCCESS';
export const FETCH_CAPACITY_INPUT_FAILURE = 'FETCH_CAPACITY_INPUT_FAILURE';
 
export const FETCH_DEFAULT_RAD_CAPACITY_REQUEST = 'FETCH_DEFAULT_CAPACITY_REQUEST';
export const FETCH_DEFAULT_RAD_CAPACITY_SUCCESS = 'FETCH_DEFAULT_CAPACITY_SUCCESS';
export const FETCH_DEFAULT_RAD_CAPACITY_FAILURE = 'FETCH_DEFAULT_CAPACITY_FAILURE';
 
export const UPDATE_RAD_CAPACITY_INPUT_REQUEST = 'UPDATE_RAD_CAPACITY_INPUT_REQUEST';
export const UPDATE_RAD_CAPACITY_INPUT_SUCCESS = 'UPDATE_RAD_CAPACITY_INPUT_SUCCESS';
export const UPDATE_RAD_CAPACITY_INPUT_FAILURE = 'UPDATE_RAD_CAPACITY_INPUT_FAILURE';
 
export const BULK_UPDATE_RAD_CAPACITY_INPUT_REQUEST = 'BULK_UPDATE_RAD_CAPACITY_INPUT_REQUEST';
export const BULK_UPDATE_RAD_CAPACITY_INPUT_SUCCESS = 'BULK_UPDATE_RAD_CAPACITY_INPUT_SUCCESS';
export const BULK_UPDATE_RAD_CAPACITY_INPUT_FAILURE = 'BULK_UPDATE_RAD_CAPACITY_INPUT_FAILURE';
 
export const RAD_CAPACITY_IP_UPLOAD_REQUEST = 'RAD_CAPACITY_IP_UPLOAD_REQUEST';
export const RAD_CAPACITY_IP_UPLOAD_SUCCESS = 'RAD_CAPACITY_IP_UPLOAD_SUCCESS';
export const RAD_CAPACITY_IP_UPLOAD_FAILURE = 'RAD_CAPACITY_IP_UPLOAD_FAILURE';